import { Tooltip } from 'antd'
import clsx from 'clsx'
import { FaqArticleDetail } from 'Modules'
import React from 'react'

import RichTextViewer from 'component/rich-text-editor/rich-text-viewer'
import { MAX_FAQ_ARTICLES_PER_CATEGORY } from 'constants/faq'
import { formatDateWithPattern } from 'utils/format-time'

import style from './faq-article-detail.module.scss'
import layout from './faq-article-layout.module.scss'

interface FaqArticleDetailViewProps {
  article: FaqArticleDetail
}

export const FaqArticleDetailView: React.FC<FaqArticleDetailViewProps> = ({ article }) => {
  const { category } = article
  const published = article.status === 'PUBLISHED'

  return (
    <div className={layout.columns}>
      <section className={layout.card}>
        <div className={style.field}>
          <div className={style.label}>Title</div>
          <div className={style.title}>{article.title}</div>
        </div>
        <div className={style.field}>
          <div className={style.label}>Content</div>
          <RichTextViewer value={article.content} />
        </div>
      </section>

      <div className={layout.sidebar}>
        <aside className={layout.card}>
          <div className={layout.cardTitle}>Settings</div>
          <div className={style.field}>
            <div className={style.label}>Category</div>
            <div className={style.category}>
              <Tooltip title={category.name}>
                <span className={style.categoryName}>{category.name}</span>
              </Tooltip>
              <span className={style.categoryCount}>
                ({category.articleCount}/{MAX_FAQ_ARTICLES_PER_CATEGORY})
              </span>
              {category.visibility === 'HIDDEN' ? (
                <span className={layout.hiddenTag}>Hidden</span>
              ) : null}
            </div>
          </div>
          <div className={style.field}>
            <div className={style.label}>Status</div>
            <span
              className={clsx(
                layout.statusTag,
                published ? layout.statusPublished : layout.statusUnpublished
              )}
            >
              {published ? 'Published' : 'Unpublished'}
            </span>
          </div>
        </aside>

        <aside className={layout.card}>
          <div className={layout.cardTitle}>Information</div>
          <div className={style.infoRow}>
            <span className={style.label}>Created date</span>
            <span className={style.infoValue}>{formatDateWithPattern(article.createdAt)}</span>
          </div>
          <div className={style.infoRow}>
            <span className={style.label}>Updated date</span>
            <span className={style.infoValue}>{formatDateWithPattern(article.updatedAt)}</span>
          </div>
        </aside>
      </div>
    </div>
  )
}
